<template>
  <b-col class="customcard col-8 mx-auto">
    <!-- <b-card class="shadow  bg-white rounded" align="center">
              <b-card-text
                ></b-card-text
              >
            </b-card> -->
    <div v-if="$root.default_academic_year[0] == '0'" style="min-height:120px"> Please select correct academic year
      to view data.</div>
    <div v-else style=" text-align: -webkit-center;">
      <b-modal id="dateSubgroupsMonitoringModel" hide-footer hide-header size="xl" append-to-body :no-enforce-focus="true">
        <DateSubgroupsAttMonitoring :date="attendanceSummaryDate" />
      </b-modal>

      <b-row align-v="center">
        <b-col class="text-left col-auto">
          <button type="button" class="btn btn-outline-info btn-sm" @click="refreshDashboardCardsAttData(-1)">
            &lt;
          </button>
        </b-col>
        <b-col class="text-center px-0">
          <h5>
            {{
                attendanceSummaryDate
                  ? `${this.attendanceSummaryDate.getDate()}/${this.attendanceSummaryDate.getMonth() +
                  1}/${this.attendanceSummaryDate.getFullYear()}`
                  : "Today's"
            }}
            Student Attendance Preview
          </h5>
        </b-col>
        <b-col class="text-right col-auto">
          <button type="button" class="btn btn-outline-info btn-sm" @click="refreshDashboardCardsAttData(1)">
            >
          </button>
        </b-col>
      </b-row>
      <b-row v-if="!attendanceSummary.dataLoaded" class="text-center" align-h="center" align-v="center">
        <b-spinner :variant="randomColor()"></b-spinner>
      </b-row>
      <!-- <b-card-text></b-card-text> -->
      <div class="mt-1" v-else v-b-modal.dateSubgroupsMonitoringModel v-on:mouseover="activeAttendanceCard = true"
        v-on:mouseleave="activeAttendanceCard = false">
        <b-row align-h="center" v-if="attendanceSummary.emptyAttendance">
          <span>No Attendance Marked</span>
        </b-row>
        <b-row v-else align-v="center" v-for="(session, sessionIndex) in attendanceSummary.sessions"
          :key="sessionIndex">
          <b-col cols="2" v-if="activeAttendanceCard">
            {{ session.name }}
          </b-col>
          <b-col>
            <b-progress style="background-image: linear-gradient(to right, #f4f6ffa6 , #f4cfb9a6) !important;"
              :height="activeAttendanceCard ? '12px' : '4px'" class="m-1" :max="attendanceSummary.studentsCount"
              v-b-tooltip.hover :title="
                'Marked for students: ' +
                attendanceSummary.sessionAttCounts[session.id].totel +
                '/' +
                attendanceSummary.studentsCount +
                ', Present: ' +
                attendanceSummary.sessionAttCounts[session.id].present +
                '/' +
                attendanceSummary.sessionAttCounts[session.id].totel +
                ', Absent: ' +
                (Number(
                  attendanceSummary.sessionAttCounts[session.id].totel
                ) -
                  Number(
                    attendanceSummary.sessionAttCounts[session.id].present
                  )) +
                '/' +
                attendanceSummary.sessionAttCounts[session.id].totel +
                ', Unmarked: ' +
                (Number(attendanceSummary.studentsCount) -
                  Number(
                    attendanceSummary.sessionAttCounts[session.id].totel
                  ))
              ">
              <b-progress-bar :label="
                activeAttendanceCard
                  ? `${(
                    (attendanceSummary.sessionAttCounts[session.id]
                      .present /
                      attendanceSummary.studentsCount) *
                    100
                  ).toFixed()}%`
                  : ''
              " variant="success" :value="
attendanceSummary.sessionAttCounts[session.id].present
"></b-progress-bar>
              <b-progress-bar :label="
                activeAttendanceCard
                  ? `${(
                    ((attendanceSummary.sessionAttCounts[session.id]
                      .totel -
                      attendanceSummary.sessionAttCounts[session.id]
                        .present) /
                      attendanceSummary.studentsCount) *
                    100
                  ).toFixed()}%`
                  : ''
              " variant="danger" :value="
attendanceSummary.sessionAttCounts[session.id].totel -
attendanceSummary.sessionAttCounts[session.id].present
"></b-progress-bar>
            </b-progress>
            <!-- <b-progress
                        height="3px"
                        :value="
                          attendanceSummary.sessionAttCounts[session.id]
                            .totel / attendanceSummary.studentsCount
                        "
                      ></b-progress> -->
          </b-col>
        </b-row>
      </div>
    </div>
  </b-col>
</template>

<script>
import DateSubgroupsAttMonitoring from "../templates/Dashboard/attendence/monitoring/dateSubgroupsAttMonitoring.vue";
export default {
  components: {
    DateSubgroupsAttMonitoring,
  },
  async created() {
    setTimeout(
      function () {
        this.getDashboardCardsAttData();
      }.bind(this),
      3000
    );
  },
  data() {
    return {
      activeAttendanceCard: false,
      attendanceSummaryDate: null,
      attendanceSummary: {
        dataLoaded: false,
        studentsCount: 0,
        sessions: [],
        sessionAttCounts: {}, //{27:{totel: 0, present: 0},}
        sessionAttFacultyCounts: {}, //{27:{totel: 0, marked: 0},}
        emptyAttendance: true,
      },
    };
  },
  methods: {
    refreshDashboardCardsAttData(day) {
      if (!this.attendanceSummaryDate) this.attendanceSummaryDate = new Date();
      this.attendanceSummaryDate.setDate(
        this.attendanceSummaryDate.getDate() + day
      );
      this.getDashboardCardsAttData();
    },
    async getDashboardCardsAttData() {
      this.attendanceSummary.dataLoaded = false;
      this.attendanceSummary.emptyAttendance = true;
      let dateString = "";
      if (this.attendanceSummaryDate)
        dateString = `${this.attendanceSummaryDate.getFullYear()}/${this.attendanceSummaryDate.getMonth() +
          1}/${this.attendanceSummaryDate.getDate()}`;
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/attendancereports/attendancesummary/count` +
        (this.attendanceSummaryDate ? `?date=${dateString}` : "");
      await this.$axios
        .get(url)
        .then((response) => {
          // console.log(response.data);
          this.attendanceSummary.studentsCount = response.data.studentsCount;
          this.attendanceSummary.sessions = response.data.sessions;
          this.attendanceSummary.sessionAttCounts =
            response.data.sessionAttCounts;
          this.attendanceSummary.sessionAttFacultyCounts =
            response.data.sessionAttFacultyCounts;

          for (const key in this.attendanceSummary.sessionAttCounts) {
            if (this.attendanceSummary.sessionAttCounts[key].totel > 0) this.attendanceSummary.emptyAttendance = false;
          }
          this.attendanceSummary.dataLoaded = true;
        })
        .catch(() => { });
    },

    randomColor() {
      return [
        "primary",
        "secondary",
        "danger",
        "warning",
        "success",
        "info",
        "light",
        "dark",
      ].sort(() => 0.5 - Math.random())[0];
    },
  },
};
</script>

<style>
.customcard {
  padding: 10px;
  margin: 7px;
  background-color: #fff;
  background-clip: border-box;
  border: 0 solid rgba(0, 0, 0, 0.125);
  border-radius: 0.75rem;
  box-shadow: 0 0 2rem 1rem #8392a426;
}
</style>
